module.exports = __webpack_public_path__ + "img/pc1.72756d7f.png";